const config = {
  MOBILE_SCREEN: 'MOBILE_SCREEN',
  DESKTOP_SCREEN: 'DESKTOP_SCREEN',
  BIG_SCREEN: 'BIG_SCREEN',
};

export default config;
